import { all, takeLatest, put, call } from 'redux-saga/effects';
import copyToClipboard from 'copy-text-to-clipboard';

import { Api } from '$api';
import { batchActions } from '$store';
import { toastActions } from '$store/toast';
import { monetizationActions } from '$store/monetization/index';
import { SendRequestAction } from '$store/monetization/interface';

function* loadMonetizationWorker() {
  try {
    const data = yield call(Api.get, '/balance/monetization');
    yield put(
      batchActions(
        monetizationActions.setMonetizationLoaded({
          status: data.status,
        }),
        monetizationActions.setSumsubToken(data.token),
        monetizationActions.setShareUrl(data.shareUrl),
      ),
    );
  } catch (e) {
    yield put(
      batchActions(
        toastActions.setToastFail(e.message),
        monetizationActions.setMonetizationFailed(),
      ),
    );
  }
}

function* sendRequestWorker(action: SendRequestAction) {
  try {
    const { contentType, links, about } = action.payload;

    yield put(toastActions.setToastLoading());
    yield call(Api.post, '/balance/monetization/request', {
      contentType,
      links,
      about,
    });
    yield put(
      batchActions(
        toastActions.setToastSuccess(),
        monetizationActions.setMonetizationStatus('in_verification'),
      ),
    );
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

function* startKYCWorker() {
  try {
    yield put(toastActions.setToastLoading());
    const data = yield call(Api.post, '/balance/monetization/start_kyc');
    yield put(
      batchActions(
        toastActions.hideToast(),
        monetizationActions.setMonetizationStatus('in_kyc'),
        monetizationActions.setSumsubToken(data.token),
        monetizationActions.setShareUrl(data.shareUrl),
      ),
    );
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

function* generateLinkWorker() {
  try {
    yield put(toastActions.setToastLoading());
    const data = yield call(Api.post, '/balance/monetization/generate_link');
    yield put(monetizationActions.setShareUrl(data.url));
    yield call(copyToClipboard, data.url);
    yield put(toastActions.setToastSuccess('Link copied to clipboard!'));
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

export function* monetizationSaga() {
  yield all([
    takeLatest(monetizationActions.loadMonetization, loadMonetizationWorker),
    takeLatest(monetizationActions.sendRequest, sendRequestWorker),
    takeLatest(monetizationActions.startKYC, startKYCWorker),
    takeLatest(monetizationActions.generateLink, generateLinkWorker),
  ]);
}
